import { Controller } from "stimulus"
import * as URI from 'urijs'

export default class extends Controller {
  apply() {
    if (event.target.value.length > 0) {
      $(event.target).parents("form").submit()
    }
  }

  enterSearch() {
    if (event.keyCode === 13) {
      this.search()
      event.preventDefault()
    }
  }

  search() {
    let query = $("#search-input")[0].value
    let url = URI(document.location.href)

    url.removeSearch("query")
    url.addSearch({ query: query })

    Turbolinks.visit(url)
  }
}
